// Upper bound (exclusive) for "this is small enough that the mobile UI is the
// right experience". 1024 covers Z Fold unfolded (~884), phone landscape, and
// iPad Mini portrait while leaving iPad Pro portrait (1024) on desktop.
export const MOBILE_VIEWPORT_MAX_PX = 1024;

// sessionStorage key set when the user explicitly taps the "Desktop view"
// button on /mobile/services. Closing the tab clears it so the next session
// starts in the mobile UI again.
export const DESKTOP_OPT_IN_KEY = 'cms2_desktop_opt_in';

export const setDesktopOptIn = (): void => {
  try {
    sessionStorage.setItem(DESKTOP_OPT_IN_KEY, 'true');
  } catch {
    // sessionStorage may be unavailable (private mode, quota). The redirect
    // simply re-fires next navigation — acceptable degradation.
  }
};

export const hasDesktopOptIn = (): boolean => {
  try {
    return sessionStorage.getItem(DESKTOP_OPT_IN_KEY) === 'true';
  } catch {
    // Same restricted-storage scenarios as setDesktopOptIn — treat the user
    // as not opted in so the redirect still fires.
    return false;
  }
};
